var PropertyTabs = function() {
  var $ = require('jquery');

  $(".js-tab-trigger").click(function(){
    var $this = $(this);
    var id = $this.data("tab");
    var $new = $(".js-tab-content[data-tab='" + id + "']");
    $(".js-tab-trigger, .js-tab-content").removeClass("active");
    $this.addClass("active");
    $new.addClass("active");
  });

}
module.exports = PropertyTabs;